import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-df631ce6")

_pushScopeId("data-v-df631ce6")
const _hoisted_1 = { class: "account_qrcode_verification flex_centers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.viewModel.retry)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          style: { width: _ctx.size + 'px', height: _ctx.size + 'px' },
          class: "qrcode"
        }, [
          (_ctx.viewModel.qrText)
            ? (_openBlock(), _createBlock(_component_QrcodeVue, {
                key: 0,
                size: _ctx.size,
                value: _ctx.viewModel.qrText,
                level: "H"
              }, null, 8, ["size", "value"]))
            : _createCommentVNode("", true)
        ], 4))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: "qrcode_fail",
          style: { width: _ctx.size + 'px', height: _ctx.size + 'px' },
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadVerificationQrCode && _ctx.loadVerificationQrCode(...args)))
        }, null, 4))
  ]))
})